export class PublishShots {
  public OrderId: number;
  public ModelId: number;
  public ColorId: number;
  public PublicationDate: string;

  constructor(orderId: number, modelId: number, colorId: number, date: string) {
    this.OrderId = orderId;
    this.ModelId = modelId;
    this.ColorId = colorId;
    this.PublicationDate = date;
  }
}
